import Call from "../../service/axios";
import {getUrl} from "../../constants/urls";
import {trackPromise} from "react-promise-tracker";

export const getInventoriesAsync = (
  {customerId, siteId},
  pageUrl = "",
  trackThisPromise = true
) => {
  const inventoriesURL = pageUrl
    ? pageUrl
    : getUrl("inventories_new_list")(customerId, siteId);
  if (trackThisPromise) {
    return trackPromise(Call.get(inventoriesURL));
  } else {
    return Call.get(inventoriesURL);
  }
};
